import { gql } from '@lcs/shared/api';

export const getActiveCallsReadOnlyQuery = gql`
   query GetActiveCallsReadOnly($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      activeCallReadOnliesConnection(
         first: $first
         filters: $filters
         after: $after
         orderingOptions: $orderingOptions
      ) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            account {
               accountId
               name
            }
            providerId
            sourceProviderId
            destinationProviderId
            callDetailId
            serverName
            callerChannelId
            sipCallId
            sourceExtension {
               extensionId
               number
               name
            }
            startTime
            callRecording {
               callRecordingId
               file {
                  fileId
               }
            }
            destinationExtension {
               extensionId
               number
               name
            }
            callDirectionTypeId
            startTime
            sourceExtensionId
            sourceNumber
            destinationExtensionId
            destinationNumber
            originalDestinationNumber
            phoneNumber {
               phoneNumberId
               phoneNumber
            }
            providerId
            sourceProviderId
            destinationProviderId
            callerName
            callDispositionTypeId
            callRate
         }
      }
   }
`;

export const getActiveCallsQuery = gql`
   query GetActiveCalls($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      activeCallsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            account {
               accountId
               name
            }
            callDetailId
            serverName
            callerChannelId
            sipCallId
            sourceExtension {
               extensionId
               number
               name
            }
            startTime
            callRecording {
               callRecordingId
               file {
                  fileId
               }
            }
            destinationExtension {
               extensionId
               number
               name
            }
            callDirectionTypeId
            sourceExtensionId
            sourceNumber
            destinationExtensionId
            destinationNumber
            originalDestinationNumber
            phoneNumber {
               phoneNumberId
               phoneNumber
            }
            providerId
            sourceProviderId
            destinationProviderId
            callerName
            callDispositionTypeId
            callRate
         }
      }
   }
`;
